import { render, staticRenderFns } from "./LaudoBacenFiscalizacaoModal.vue?vue&type=template&id=ec6aaa56&scoped=true&lang=pug"
import script from "./LaudoBacenFiscalizacaoModal.vue?vue&type=script&lang=js"
export * from "./LaudoBacenFiscalizacaoModal.vue?vue&type=script&lang=js"
import style0 from "./LaudoBacenFiscalizacaoModal.vue?vue&type=style&index=0&id=ec6aaa56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6aaa56",
  null
  
)

export default component.exports